module.exports = __webpack_public_path__ + "static/media/LoadArchiver.ed41bfe7.png";